<template>
    <v-form
        ref="form"
        v-model="valid"
        @submit="onSubmit"
        :disabled="is_disabled">

        <v-container fluid>
            <v-row>
                <v-col md="6" cols="12">
                    <!-- integration label -->
                    <v-text-field
                        v-model="form.label"
                        :error-messages="labelErrors"
                        :counter="180"
                        label="Integration label"
                        required
                        @input="$v.form.label.$touch()"
                        @blur="$v.form.label.$touch()"
                        :readonly="is_disabled">
                    </v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                    <!--
                        Platform

                        This is a v-autocomplete, not a v-select. VSelect's
                        type-ahead (VSelect.onKeyPress) sets the value straight
                        from a text-prefix match and never consults
                        item-disabled, so typing "com" + Enter could select a
                        closed platform. VAutocomplete uses a real search input
                        and never binds that handler.
                    -->
                    <v-autocomplete
                        v-model="form.integration_type_id"
                        :items="integrations"
                        :error-messages="typeErrors"
                        :rules="[v => !!v || 'Platform is required']"
                        :readonly="is_disabled"
                        label="Platform"
                        required>
                        <template v-slot:item="{ item, on, attrs }">
                            <v-list-item v-bind="attrs" v-on="on" :disabled="item.disabled">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="item.reason">
                                        {{ item.reason }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>

            <v-row v-if="!is_disabled && submitText !== 'Update'">
                <v-col md="6" cols="12">
                    <!-- integration account -->
                    <v-autocomplete
                        v-model="form.integ_id"
                        :items="integs"
                        clearable
                        label="Copy Configuration from">
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row class="mt-5">
                <v-col>
                    <v-tabs
                        class="fusedship-tab"
                        background-color="white"
                        color="dark"
                        show-arrows="mobile">
                        <v-tab href="#tab-settings">
                            Settings
                        </v-tab>
                        <v-tab v-if="is_disabled || submitText === 'Update'" href="#tab-machship">
                            Machship
                        </v-tab>
                        <v-tab v-if="is_disabled || (submitText === 'Update' && platform !== '')" href="#tab-platform">
                            Platform Settings
                        </v-tab>
                        <v-tab v-if="is_disabled || (submitText === 'Update' && platform !== '' && hasLiverates)" href="#tab-liverates">
                            Live Rates
                        </v-tab>
                        <v-tab v-if="is_disabled || submitText === 'Update'" href="#tab-filters">
                            Filters
                        </v-tab>
                        <v-tab v-if="!is_disabled && submitText !== 'Update'" href="#tab-account">
                            Link/Add Account
                        </v-tab>
                        <v-tab ref="tabBilling" v-if="submitText === 'Update' && isAdmin" href="#tab-billing">
                            Billing
                        </v-tab>
                        <v-tab v-if="submitText === 'Update' && isAdmin" href="#tab-account-select">
                            Account
                        </v-tab>
                        <v-tab v-if="submitText === 'Update' && isAdmin" href="#tab-machship-webhook">
                            Machship Webhook
                        </v-tab>
                        <v-tab v-if="(is_disabled || (submitText === 'Update' && platform !== '')) && isAdmin" href="#tab-notes">
                            <div style="min-width: -webkit-fill-available;">
                                WIKI
                            </div>
                        </v-tab>
                        <v-tab v-if="(is_disabled || (submitText === 'Update' && platform !== '')) && isAdmin" href="#tab-debugging">
                            <div style="min-width: -webkit-fill-available;">
                                Debugging
                            </div>
                        </v-tab>

                        <v-tab-item value="tab-settings">
                            <v-container fluid>
                                <v-row>
                                    <v-col md="8" cols="12">

                                        <v-container fluid>
                                            <v-row>
                                                <v-col md="3" cols="12">
                                                    <!-- frequency -->
                                                    <v-text-field
                                                        v-model="form.frequency_mins"
                                                        :error-messages="frequencyErrors"
                                                        label="Frequency by mins"
                                                        @input="$v.form.frequency_mins.$touch()"
                                                        @blur="$v.form.frequency_mins.$touch()"
                                                        :readonly="is_disabled">
                                                    </v-text-field>
                                                </v-col>

                                                <v-col md="3" cols="12">
                                                    <!-- offset -->
                                                    <v-text-field
                                                        v-model="form.offset"
                                                        :error-messages="offsetErrors"
                                                        label="Offset sync by mins"
                                                        @input="$v.form.offset.$touch()"
                                                        @blur="$v.form.offset.$touch()"
                                                        :readonly="is_disabled">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                        v-model="form.expire_status"
                                                        :readonly="is_disabled"
                                                        label="Expire Status by days">
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                        v-model="form.expire_data"
                                                        :readonly="is_disabled"
                                                        label="Expire Data by days">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row v-if="submitText == 'Add' && isAdmin" fluid>
                                                <v-col class="p-0">
                                                    <BillingForm
                                                        :form="form"
                                                        :is_disabled="is_disabled"></BillingForm>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-col>
                                    <v-col md="4" cols="12">
                                        <div class="pl-5">
                                            <v-switch
                                                :readonly="is_disabled"
                                                v-model="form.is_pending"
                                                @change="onPendingChanged"
                                                label="">
                                                <template v-slot:label>
                                                    <span>Is Pending Consignment</span>
                                                </template>
                                            </v-switch>
                                        </div>
                                        <div class="pl-5">
                                            <v-switch
                                                v-if="isPriorityShow"
                                                :readonly="is_disabled"
                                                v-model="form.is_priority_sync"
                                                label="">
                                                <template v-slot:label>
                                                    <span>Is Priority Sync</span>
                                                </template>
                                            </v-switch>
                                        </div>

                                        <div class="pl-5">
                                            <v-switch
                                                :readonly="is_disabled"
                                                v-model="form.is_check_consignment"
                                                @change="isCheckRunConsignment()">
                                                <template v-slot:label>
                                                    <span>Recently Updated Job Frequency</span>
                                                </template>
                                            </v-switch>
                                        </div>
                                        <div v-if="isCheckRun">
                                            <!-- check_consignment -->
                                            <v-select
                                                v-model="form.check_consignment"
                                                label="Checks every"
                                                :items="checkintervals"
                                                :readonly="is_disabled">
                                            </v-select>
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row v-if="!is_disabled">
                                    <v-col>
                                        <div class="mt-3 d-flex">
                                            <v-spacer></v-spacer>
                                            <v-btn type="submit" small class="mr-1" color="primary" :disabled="isSubmit" >
                                                <v-progress-circular
                                                    v-if="isSubmit"
                                                    indeterminate
                                                    size="12"
                                                    width="2"
                                                    color="primary"
                                                    class="mr-1">
                                                </v-progress-circular>
                                                {{ submitText }}
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>

                        <v-tab-item value="tab-machship">
                            <!-- machship setup -->
                            <integrations-machship
                                v-if="integration"
                                :integrationId="integration.id"
                                :integrationKeys="integration.keys"
                                :check_test_mode="integration.is_test"
                                :is_disabled="is_disabled">
                            </integrations-machship>
                        </v-tab-item>

                        <v-tab-item value="tab-platform">
                            <integrations-meta
                                v-if="integration"
                                :integration="integration"
                                :hasOauth2="integration.has_oauth2"
                                :hasOauth1="integration.has_oauth1"
                                :integrationId="integration.id"
                                :integrationMeta="integration.metas | onlyPlatformMeta"
                                :is_disabled="is_disabled">
                            </integrations-meta>
                        </v-tab-item>

                        <v-tab-item value="tab-liverates">
                            <LiveratesConfigrations
                                v-if="integration"
                                :integration_type_id="integration.integration_type_id"
                                :integrationMeta="integration.metas | onlyLiveratesMeta"
                                :isDisabled="is_disabled" />
                        </v-tab-item>

                        <v-tab-item value="tab-filters">
                            <!-- filter data source -->
                            <integrations-filters-tabs
                                v-if="integration"
                                :integrationId="integration.id"
                                :integrationFilters="integration.filters"
                                :is_disabled="is_disabled">
                            </integrations-filters-tabs>
                        </v-tab-item>

                        <v-tab-item value="tab-account">
                            <Account
                                :is_disabled="true"
                                :linkAccount="true"
                                :newAccount="true"
                                :forEdit="false"
                                submitText="Link"
                            ref="addaccount"/>
                        </v-tab-item>

                        <v-tab-item value="tab-notes">
                            <integrations-note
                            v-if="integration"
                            :integration="integration"
                            :is_disabled="is_disabled"
                            adminRights="isAdmin"/>
                        </v-tab-item>

                        <v-tab-item value="tab-debugging">
                            <Debugging
                            v-if="integration"
                            :integration="integration"
                            :is_disabled="is_disabled"
                            adminRights="isAdmin"/>
                        </v-tab-item>

                        <v-tab-item value="tab-billing">
                            <BillingForm
                                v-if="integration"
                                :form="form"
                                :is_disabled="is_disabled"
                                :isForm="true" />
                        </v-tab-item>

                        <v-tab-item value="tab-account-select">
                            <v-container fluid>
                                <v-row class="mt-3">
                                    <v-col md="6">
                                        <v-select
                                            v-model="form.account_id"
                                            :items="accounts"
                                            label="Account"
                                            >
                                        </v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="6">
                                        <v-btn type="submit" small class="mr-1" color="primary" :disabled="isSubmit" >
                                            <v-progress-circular
                                                v-if="isSubmit"
                                                indeterminate
                                                size="12"
                                                width="2"
                                                color="primary"
                                                class="mr-1">
                                            </v-progress-circular>
                                            {{ submitText }}
                                        </v-btn>
                                        <v-btn to="/accounts/add" small>Add New</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>

                        <v-tab-item value="tab-machship-webhook">
                            <MachshipWebhookForm
                                v-if="integration"
                                :is_disabled="is_disabled"
                                :integrationMeta="integration.metas | onlyMachshipWebhook"
                                :integrationId="integration_id" />
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, numeric } from 'vuelidate/lib/validators'
import { EventBus } from '@/js/event-bus.js'
import IntegrationsMachship from '../IntegrationsMachship'
import IntegrationsMeta from './IntegrationsMeta'
import IntegrationsFiltersTabs from './IntegrationsFiltersTabs'
import MachshipWebhookForm from './MachshipWebhookForm'
import LiveratesConfigrations from '~/liverates/components/LiveratesConfigurations'
import Account from '~/accounts/AccountAdd';
import IntegrationsNote from './IntegrationsNote';
import Debugging from '../tabs/debugging';
import BillingForm from '../tabs/billing/BillingForm';


export default {
    components: {
        IntegrationsMachship,
        IntegrationsMeta,
        IntegrationsFiltersTabs,
        MachshipWebhookForm,
        LiveratesConfigrations,
        Account,
        IntegrationsNote,
        Debugging,
        BillingForm,
    },
    mixins: [validationMixin],
    validations: {
        form : {
            label: { required },
            integration_type_id: { required },
            frequency_mins: { required, numeric },
            offset: { required, numeric },
            check_consignment: { numeric },
        }
    },
    filters: {
        onlyPlatformMeta(metas) {
            if (!metas) {
                return [];
            }

            return metas.filter(meta => {
                return meta.meta_key.indexOf('LIVE_RATE') < 0 && typeof meta.note_only === 'undefined'
            });
        },

        onlyLiveratesMeta(metas) {
            if (!metas) {
                return [];
            }

            return metas.filter(meta => {
                return meta.meta_key.indexOf('LIVE_RATE') >= 0
            })
        },
        onlyNoteMeta(metas) {
            if (!metas) {
                return [];
            }

            return metas.filter(meta => {
                return meta.meta_key.indexOf('INTEGRATION_NOTE') >= 0
            })
        },

        onlyMachshipWebhook(metas) {
            if (!metas) {
                return [];
            }

            return metas.filter(meta => {
                return meta.meta_key.indexOf('MSWEBHOOK_ENABLE') >= 0
            })
        }
    },
    props: {
        integration:      { type: Object, default: () => {} },
        submitText:       { type: String, default: 'Add' },
        integration_type_id: { type: Number, default: null },
        submit:           { type: Function, default: () => {} },
        isSubmit:         { type: Boolean, default: false },
        integration_id:   { type: Number, default: null },
        is_disabled:      { type: Boolean, default: false }
    },
    data() {
        return {
            valid: false,
            platformTypes: [],
            accounts: [],
            integs: [],
            isAdmin: false,
            isCheckRun: false,
            isPriorityShow: false,
            checkintervals: [
                { value: '1', text: '1 minute' },
                { value: '5', text: '5 minutes' },
                { value: '10', text: '10 minutes' },
                { value: '30', text: '30 minutes' }
            ],

            // form inputs
            form: {
                label: null,
                integration_type_id: null,
                frequency_mins: 5,              // default upon creating new integration
                integ_id: null,
                account_id: null,
                is_pending: 'PENDING',          // default upon creating new integration
                is_priority_sync: false,
                check_consignment: 10,          // default upon creating new integration
                is_check_consignment: 'active',
                offset: 10,                     // default upon creating new integration
                expire_status: 90,              // default upon creating new integration
                expire_data: 120,               // default upon creating new integration
                expiration: null,
                charge_monthly_from: null,
                charge_setup_on: null,

                company_id: null,
                org_id: null,

                setup_fee: null,
                monthly_fee: null,
                setup_charged: null,
                monthly_charged: null
            },

            dateMenu: false,
            dateChargeSetupMenu: false,
        }
    },

    created() {
        this.$on('reset-submit', () => {
            this.$emit('update:isSubmit', false);
        });
        // we need to fetch all accounts
        this.onFetchAllOptions()

        if (this.integration) {

            // This will be much simplier since we will be needing most of the integration data
            this.form = { ...this.integration }

            // then remove the unnessary fields
            delete(this.form.last_run)
            delete(this.form.master_consignment_type)
            delete(this.form.run_check_consignment)
            delete(this.form.expiration)
            delete(this.form.field_mapper)
            delete(this.form.has_oauth2)
            delete(this.form.has_oauth1)
            delete(this.form.last_syncs)
            delete(this.form.updated_at)
            delete(this.form.value_lookup)
            delete(this.form.filters)
            delete(this.form.integration_type)
            delete(this.form.metas)


            this.form.is_pending = this.integration.master_consignment_type == 'PENDING'
            this.form.is_check_consignment = this.integration.run_check_consignment == 'active'

            this.form.expire_status = this.integration.expiration.status
            this.form.expire_data = this.integration.expiration.data

            if (!this.is_disabled) {
                this.form.integ_id = this.integration.integ_id
            }
            if (this.integration.run_check_consignment == 'active') {
                this.isCheckRun = true
            }

            // show only priority sync if its not pending mode
            this.isPriorityShow = !this.form.is_pending
        }
        else {
            this.isCheckRun = true
        }
    },

    computed: {
        labelErrors() {
            const errors = []
            if (!this.$v.form.label.$dirty) return errors
            // !this.$v.form.label.maxLength && errors.push('Label must be at most 10 characters long')
            !this.$v.form.label.required && errors.push('Label is required.')
            return errors
        },
        typeErrors() {
            const errors = []
            if (!this.$v.form.integration_type_id.$dirty) return errors
            !this.$v.form.integration_type_id.required && errors.push('Integration type is required.')
            return errors
        },
        frequencyErrors() {
            const errors = []
            if (!this.$v.form.frequency_mins.$dirty) return errors
            !this.$v.form.frequency_mins.numeric && errors.push('Frequency must be numeric')
            !this.$v.form.frequency_mins.required && errors.push('Frequency is required.')
            return errors
        },
        offsetErrors() {
            const errors = []
            if (!this.$v.form.offset.$dirty) return errors
            !this.$v.form.offset.numeric && errors.push('Frequency must be numeric')
            !this.$v.form.offset.required && errors.push('Frequency is required.')
            return errors
        },
        checkConsignmentErrors() {
            const errors = []
            if (!this.$v.form.check_consignment.$dirty) return errors
            !this.$v.form.check_consignment.numeric && errors.push('Run Recently Updated Job must be numeric')
            return errors
        },

        companyErrors() {
            const errors = []
            if (!this.$v.form.company_id.$dirty) return errors
            !this.$v.form.company_id.numeric && errors.push('Company id must be numeric')
            return errors
        },

        organizationErrors() {
            const errors = []
            if (!this.$v.form.org_id.$dirty) return errors
            !this.$v.form.org_id.numeric && errors.push('Orgnaization id must be numeric')
            return errors
        },

        setupFeeError() {
            const errors = []
            if (!this.$v.form.org_id.$dirty) return errors
            !this.$v.form.org_id.numeric && errors.push('Setup fee must be numeric')
            return errors
        },

        monthlyFeeError() {
            const errors = []
            if (!this.$v.form.org_id.$dirty) return errors
            !this.$v.form.org_id.numeric && errors.push('Monthly fee must be numeric')
            return errors
        },

        /**
         * Platform options for the select.
         *
         * A platform that is closed to new integrations cannot be picked, but
         * the one this integration already sits on stays selectable so Edit
         * and View render its name normally.
         */
        integrations() {
            let selected = parseInt(this.form.integration_type_id)

            return this.platformTypes.map(type => {
                let locked = !type.is_open && type.id !== selected

                return {
                    value: type.id,
                    text: type.display_name,
                    reason: type.is_open ? '' : 'Ported to MachShip Connect',
                    disabled: locked,
                }
            })
        },

        platform() {
            let id = this.integration_type_id
            let index = this.integrations.findIndex(integration => {
                return integration.value == id
            })

            return index < 0 ? '' : this.integrations[index].text
        },

        hasLiverates() {
            return this.integration?.live_rate_active;
        },
    },

    mounted() {
        this.isAdmin = this.$store.getters.isAdmin
    },

    methods: {
        isCheckRunConsignment() {
            this.isCheckRun = this.form.is_check_consignment ? true : false
        },

        getNewAccount() {
            return typeof this.$refs.addaccount !== 'undefined' ? this.$refs.addaccount.hasAccId() : 0
        },
        onSubmit(e) {

            e.preventDefault();

            // always gives time to background to process before it submits
            setTimeout(() => {
                this.$v.form.$touch();

                if (this.valid) {
                    // update integration's consignment type
                    this.form.master_consignment_type = this.form.is_pending ? 'PENDING' : 'MANIFEST'

                    // remove from update
                    delete(this.form.integration_status)
                    delete(this.form.live_rate_active)
                    delete(this.form.is_test)

                    this.form.run_check_consignment = this.form.is_check_consignment ? 1 : 0

                    // call callback submit

                    let expireArr = [];
                    if (this.form.expire_status) {
                        expireArr.push({'status':this.form.expire_status})
                    }
                    if (this.form.expire_data) {
                        expireArr.push({'data':this.form.expire_data})
                    }
                    if (expireArr.length) {
                        this.form.expiration = expireArr
                    }


                    this.submit(this.form)
                } else {
                    EventBus.$emit('show-error', 'Please fill in all required fields.');
                    this.$emit('update:isSubmit', false);
                }

            }, 300);

        },
        clear() {
            this.$refs.form.reset()
        },

        onFetchAllOptions() {
            this.$http
                .get('/api/accounts', { params: { limit: -1 } })
                .then(({ data }) => {
                    this.accounts = data.data.map(account => {
                        return { value: parseInt(account.id), text: account.attributes.client_name }
                    })
                })
                .catch(err => {
                    EventBus.$emit('show-error', 'Failed to fetch users.');
                })
            this.$http
                .get('/api/integrations', { params: { limit: -1 } })
                .then(({ data }) => {
                    this.integs = data.data.map(integration => {
                        return { value: parseInt(integration.id), text: integration.attributes.label }
                    })
                })
                .catch(err => {
                    EventBus.$emit('show-error', 'Failed to fetch users.');
                })

            this.$http
                .get('/api/integrationtypes', { params: { limit: -1, sortBy: 'display_name', sortDesc: false } })
                .then(({ data }) => {
                    this.platformTypes = data.data.map(type => {
                        return {
                            id: parseInt(type.id),
                            display_name: type.attributes.display_name,
                            // is_active false means the platform is closed to new
                            // integrations - MSC3-1266. Existing ones still work.
                            is_open: type.attributes.is_active,
                        }
                    })
                })
                .catch(err => {
                    EventBus.$emit('show-error', 'Failed to fetch integration types.');
                })
        },

        onPendingChanged(isPending) {

            if (isPending) {
                this.isPriorityShow = false
                this.form.is_priority_sync = false
            } else {
                this.isPriorityShow = true
            }

        },

        switchToBillingTab() {
            this.$refs.tabBilling.$el.click();
        }
    },
}
</script>
